import ButtonContent from './ButtonContent'

export default function Link({ href, children, input, isloading }) {
  return (
    <a className="button" href={href} {...input}>
      <ButtonContent input={input} isloading={isloading}>
        {children}
      </ButtonContent>
    </a>
  )
}